import { render, staticRenderFns } from "./GynecologyInfoItem.vue?vue&type=template&id=679d0141&"
import script from "./GynecologyInfoItem.vue?vue&type=script&lang=js&"
export * from "./GynecologyInfoItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports